<template>
  <div class="container">
	  <div class="loginContent">
		  <div class="w1600">
			 <div class="registerForm">
			 	<div class="loginForm p3 bd10">
			 			<h3 class="font28">申请试用账号</h3>
			 			<p class="font18 font-light tip cor999">申请一个Site ID以注册您的账户来试用平台功能</p>
			 			<div class="rgStep3">
			 				<div class="form">
			 					<dl>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">您的公司<tip></tip></div>
			 							<div class="enter d-flex">
			 								<input type="text" class="input font-light" placeholder="请输入您的公司名称">
			 							</div>
			 						</dd>
			 						<dd class="d-flex j-sb">
			 							<div class="item">
			 								<div class="label font-medium">您的名</div>
			 								<div class="enter">
			 									<input type="text" class="input font-light" placeholder="请输入您的名">
			 								</div>
			 							</div>
			 							<div class="item">
			 								<div class="label font-medium">您的姓</div>
			 								<div class="enter">
			 									<input type="text" class="input font-light" placeholder="请输入您的姓氏">
			 								</div>
			 							</div>
			 						</dd>
			 						<dd class="d-flex j-sb">
			 							<div class="item">
			 								<div class="label font-medium">您的国家</div>
			 								<div class="enter">
			 									<input type="text" class="input font-light" placeholder="请输入您的国家">
			 								</div>
			 							</div>
			 							<div class="item">
			 								<div class="label font-medium">您的州/省</div>
			 								<div class="enter">
			 									<input type="text" class="input font-light" placeholder="请输入您的州/省">
			 								</div>
			 							</div>
			 						</dd>
			 						<dd class="d-flex j-sb">
			 							<div class="item">
			 								<div class="label font-medium">您的城市</div>
			 								<div class="enter">
			 									<input type="text" class="input font-light" placeholder="请输入您的城市">
			 								</div>
			 							</div>
			 							<div class="item">
			 								<div class="label font-medium">所在地邮政编码</div>
			 								<div class="enter">
			 									<input type="text" class="input font-light" placeholder="请输入邮政编码">
			 								</div>
			 							</div>
			 						</dd>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">详细地址</div>
			 							<div class="enter">
			 								<input type="text" class="input font-light" placeholder="请输入详细地址">
			 							</div>
			 						</dd>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">公司详细地址</div>
			 							<div class="enter">
			 								<input type="text" class="input font-light" placeholder="请输入详细地址">
			 							</div>
			 						</dd>
			 						<dd class="d-flex f-colu">
			 							<div class="label font-medium">申请试用产品<tip></tip></div>
			 							<div class="enter">
			 								<select name="" id="" class="input">
			 									<option value="">选择产品</option>
			 								</select>
			 							</div>
			 						</dd>
			 					</dl>
			 				</div>
			 				<div class="submit d-flex f-colu">
			 					<button class="fmBtn font20 w100 font-medium pointer">申请试用账号</button>
			 					<p class="d-flex j-end">有Site ID？<a href="javascript:;" @click="goToPage('/register')">立即注册</a></p>
			 				</div>
			 			</div>
			 			
			 	</div>
			 	<!-- 弹窗提示 -->
			 	<popup v-show="false">
			 		<div class="slot d-flex f-colu j-center a-center line-md">
			 			<img src="@/assets/Icons/error.png" alt="">
			 			输入的Site ID与邮箱后缀不匹配！
			 		</div>
			 	</popup>
			 </div>
		  </div>
	  </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyForTest',
  data() {
    return {
		
	}
  },
  
  
  methods: {
	  tableContent(index) {
		  this.currentContent = index;
	  },
	  
	  // 页面跳转
	  goToPage(path, query={}) {
		  this.$router.push({
			path,
			query
		  })
	  }
  }
}
</script>

<style lang="less" scoped>
	.container{
		background: #f2f5fa;
	}
	.loginContent{
		padding: .6rem 0;
	}
	.loginForm{
		max-width: 500px;
		width: 100%;
		padding-top: .5rem;
		padding-bottom: .5rem;
		border-radius: 0;
		margin: 0 auto;
		.tip{
			margin: .15rem 0 .4rem;
		}
		dl{
			dd{
				.label{
					margin-bottom: .1rem;
				}
				&:not(:last-child) {
					margin-bottom: .3rem;
				}
				.fmBtn{
					width: 1.1rem;
				}
				.input,.fmBtn{
					border-radius: 0;
				}
				.code .input{
					width: calc(100% - 1.1rem);
				}
				.item{
					width: 48%;
				}
			}
		}
		.rgStep1{
			.submit{
				button{
					width: 48%;
				}
				.back{
					background: #f5f6f8;
					color: #224ed9;
					&:hover{
						box-shadow: 2px 2px 2px rgba(0,0,0,.1);
					}
				}
			}
		}
		.submit{
			margin-top: .4rem;
			p{
				margin-top: .4rem;
				a{
					color: #224ed9;
					padding-bottom: .1rem;
					border-bottom: solid 1px #224ed9;
				}
			}
		}
	}
</style>
